import { useMemo, useState } from "react";
import { getFamiliasAll } from "../../../services/backend/catalogService";
import { flattenFamilias } from "../components/shared/flattenFamilias";
import useAdminFetch from "../hooks/useAdminFetch";

const tipoOptions = [
    { label: "B2B", value: "B2B" },
    { label: "B2C", value: "B2C" },
];

const buildChildren = (hijos, parentKey) => {
    if (!Array.isArray(hijos)) return [];
    return hijos.map((hijo, index) => ({
        key: `${parentKey}-${index}`,
        data: {
            name: hijo.nombre || "",
            id: hijo.id || 0,
            orden: hijo.orden || 0,
            activa: hijo.activa ?? true,
            raw: hijo,
        },
        children: buildChildren(hijo.hijos, `${parentKey}-${index}`)
    }));
};

const buildTreeNodes = (familias) => {
    return familias.map((familia, index) => ({
        key: String(index),
        data: {
            name: familia.nombre || "",
            id: familia.id || 0,
            orden: familia.orden || 0,
            activa: familia.activa ?? true,
            raw: familia,
        },
        children: buildChildren(familia.hijos, String(index))
    }));
};

const useFamiliaTree = ({ onError } = {}) => {
    const [selectedFamilia, setSelectedFamilia] = useState(null);
    const [selectedFamiliaData, setSelectedFamiliaData] = useState(null);
    const [tipo, setTipo] = useState("B2B");
    const [activas, setActivas] = useState(true);

    const { rows: familiasRaw, loading, reload } = useAdminFetch(
        () => getFamiliasAll({ tipo, activas }),
        {
            deps: [tipo, activas],
            transform: (response) =>
                Array.isArray(response?.familias) ? response.familias : [],
            onError,
        }
    );

    const nodes = useMemo(() => buildTreeNodes(familiasRaw), [familiasRaw]);
    const familiasFlat = useMemo(() => flattenFamilias(familiasRaw), [familiasRaw]);

    const onNodeSelect = (node) => {
        setSelectedFamiliaData(node?.data);
    };

    const onNodeUnselect = () => {
        setSelectedFamiliaData(null);
    };

    return {
        tipoOptions,
        tipo,
        setTipo,
        activas,
        setActivas,
        selectedFamilia,
        setSelectedFamilia,
        selectedFamiliaData,
        setSelectedFamiliaData,
        familiasFlat,
        loading,
        reload,
        nodes,
        onNodeSelect,
        onNodeUnselect,
    };
};

export default useFamiliaTree;